/** Közös formázók. Egy helyen, hogy a felület egységes maradjon. */

export function huf(amount: number | null | undefined): string {
  if (amount == null) return "—";
  return `${amount.toLocaleString("hu-HU")} Ft`;
}

export function usd(amount: number | null | undefined): string {
  if (amount == null) return "—";
  return `$${amount.toFixed(amount < 1 ? 4 : 2)}`;
}

export function percent(value: number | null | undefined): string {
  if (value == null) return "—";
  return `${Math.round(value * 100)}%`;
}

export function ms(value: number | null | undefined): string {
  if (value == null) return "—";
  return value >= 1000 ? `${(value / 1000).toFixed(1)} s` : `${value} ms`;
}

export function datetime(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleString("hu-HU", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
}

/** „3 perce”, „2 napja” — a listákban ez olvashatóbb a teljes dátumnál. */
export function ago(iso: string | null | undefined): string {
  if (!iso) return "—";
  const diff = Date.now() - new Date(iso).getTime();
  if (Number.isNaN(diff)) return "—";
  const perc = Math.floor(diff / 60000);
  if (perc < 1) return "most";
  if (perc < 60) return `${perc} perce`;
  const ora = Math.floor(perc / 60);
  if (ora < 24) return `${ora} órája`;
  const nap = Math.floor(ora / 24);
  return nap < 30 ? `${nap} napja` : datetime(iso);
}

/**
 * A kimeneteli sávok emberi neve és hangulata.
 *
 * A `visszakerdezes` és az `emberi_ellenorzes` NEM hiba: a rendszer
 * tervezett viselkedése, hogy bizonytalanság esetén kérdez vagy emberhez
 * irányít (A7). A felület ezért nem pirosan jelöli őket.
 */
export const OUTCOME: Record<string, { label: string; tone: string }> = {
  automatikus: { label: "Automatikus", tone: "ok" },
  figyelmeztetes: { label: "Figyelmeztetés", tone: "warn" },
  visszakerdezes: { label: "Visszakérdezés", tone: "info" },
  emberi_ellenorzes: { label: "Emberi ellenőrzés", tone: "info" },
  nem_beutalo: { label: "Nem beutaló", tone: "muted" },
};

export function outcomeLabel(value: string | null | undefined): string {
  if (!value) return "—";
  return OUTCOME[value]?.label ?? value;
}

export function outcomeTone(value: string | null | undefined): string {
  if (!value) return "muted";
  return OUTCOME[value]?.tone ?? "muted";
}
